document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll("[data-animate-section]");
  if (!sections.length) return;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const section = entry.target;

        const animatedElements = section.querySelectorAll("[data-animate]");

        animatedElements.forEach((el) => {
          const delay = el.dataset.delay;
          if (delay) {
            el.style.transitionDelay = `${delay}s`;
          }
        });

        section.classList.add("is-in-view");

        observer.unobserve(section);
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: "0px 0px -30% 0px",
    },
  );

  sections.forEach((section) => {
    observer.observe(section);
  });
});
